// helper method to render all the list items.
import * as _ from "lodash";
import GameListItem from "./GameListItem";
import React from "react";

export const GameListing = ({games, onGameSelect, showAuthor}) => {
   if (!games) {
      return <div>Loading...</div>;
   }
   if (Object.keys(games).length === 0) {
      return <h5>None</h5>;
   }
   // foreach game in gameMap...
   return _.values(games).map((game) => {

      // return a GameListItem
      return (
         <GameListItem
            key={game.id}
            game={game}
            adminView={showAuthor}
            onGameSelect={onGameSelect}/>
      );
   });
};


// WEBPACK FOOTER //
// ./src/components/yourpage/GameListing.js